export default __webpack_public_path__ + "static/SRF 4400 - Fiche de spécifications et données techniques-2fd3aad444ab221355f78699e6e7b8d3.pdf";